import React from "react";

import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableCellProps,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { OmittedMeasureTableDataRow } from "store/types";

import { Row } from "./Row";

const cellCommonStyles: TableCellProps["sx"] = {
  backgroundColor: "#edf1f9",
  color: "#0a3142",
  fontSize: "15px",
  fontWeight: "normal",
  border: "none",
  whiteSpace: "nowrap"
};

const columns = ["", "Parameter", "Value", "Investor", "Date", "Entered By"];

interface ICashflowProps {
  data: OmittedMeasureTableDataRow[];
  loading: boolean;
}

export const Cashflow: React.FC<ICashflowProps> = ({ data, loading }) => {
  return (
    <>
      {loading ? (
        <Skeleton variant="rounded" width="100%" height="100%" sx={{ flexGrow: 1, maxHeight: 160, minHeight: 160 }} />
      ) : (
        <TableContainer
          sx={{
            borderRadius: "8px",
            boxShadow: "none",
            border: "0.5px solid #dae0e2",
            overflowX: "auto"
          }}
        >
          <Table
            sx={{
              ".MuiTableCell-root": {
                padding: "5px 26px"
              }
            }}
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {columns.map((col) => {
                  return (
                    <TableCell key={col} sx={cellCommonStyles}>
                      {col}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <Row key={index} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};
